import { Grid, Row } from 'antd'
import CreateRental from 'app/components/Core/Project/CreateRental'
import Info from 'app/components/Core/Project/Info'
import StatusInfo from 'app/components/Core/Rental/StatusInfo'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

import MachineList from './MachineList'

type Props = {
  project: IProject
}

const Project: React.FC<Props> = ({ project }) => {
  const { lg } = Grid.useBreakpoint()
  const { tRoute } = useTranslation({ scope: 'project.show' })

  return (
    <Row gutter={[{ xs: 0, md: 12 }, 12]}>
      <KCol xs={24} lg={16}>
        <Row gutter={[{ xs: 0, md: 12 }, 12]}>
          <KCol
            hidden={project && !project.actions.length}
            card
            span={24}
            loading={!project}
            title={tRoute({ id: 'actions' })}>
            <If condition={project}>
              {project.actions.map((action, index) => (
                <StatusInfo key={index} member={{ status_info: action, id: action.rental_id }} />
              ))}
            </If>
          </KCol>
          <If condition={project}>
            <KCol span={24} card hidden={lg} cardProps={{ className: 'text-center pt-3' }}>
              <CreateRental member={project} />
            </KCol>
          </If>
          <If condition={project}>
            <MachineList props={{ params: { projectId: project?.id } }} />
          </If>
        </Row>
      </KCol>
      <KCol xs={24} lg={8}>
        <Row gutter={[0, 12]}>
          <KCol card span={24} title={tRoute({ id: 'project_infos' })} loading={!project}>
            <If condition={project}>
              <Info member={project} />
            </If>
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

export default Project
